export enum AzureUploadContainerType {
  // eslint-disable-next-line no-unused-vars
  Attachments = 'Attachments',
  // eslint-disable-next-line no-unused-vars
  SafetyReport = 'SafetyReport',
}
